const ROL = Object.freeze({
  ADMIN: 'ADMIN',
  RISK_SHIELD: 'RISK_SHIELD',
  ANALYST: 'ANALYST',
  COMPANY: 'COMPANY',
  COMPANY_ADMIN: 'COMPANY_ADMIN',
  COMPANY_COMPLIANCE: 'COMPANY_COMPLIANCE',
  COMPLIANCE: 'COMPLIANCE',
  COMPLIANCE_ADMIN: 'COMPLIANCE_ADMIN',
  RISK_SHIELD_ADMIN: 'RISK_SHIELD_ADMIN',
  CLIENT_APPROVER: 'CLIENT_APPROVER',
  ACCOUNTING: 'ACCOUNTING',
})

const ROLES = Object.freeze({
  [ROL.ADMIN]: 'Administrador',
  [ROL.RISK_SHIELD]: 'Risk Shield',
  [ROL.ANALYST]: 'Analista',
  [ROL.COMPANY]: 'Atracción Talento',
  [ROL.COMPANY_ADMIN]: 'Administrador de Atracción Talento',
  [ROL.COMPANY_COMPLIANCE]: 'Cliente Cumplimiento',
  [ROL.COMPLIANCE]: 'Cumplimiento',
  [ROL.COMPLIANCE_ADMIN]: 'Administrador de cumplimiento',
  [ROL.RISK_SHIELD_ADMIN]: 'Administrador Risk',
  [ROL.CLIENT_APPROVER]: 'Aprobador del cliente',
  [ROL.ACCOUNTING]: 'Contabilidad'
})

const getRoleName = (rol) => ROLES[rol]

export {
  ROL,
  ROLES,
  getRoleName
}
